export const adminDashboardData = {
  primarySidebarNavs: [
    { key: 'liveOrders', icon: 'fas fa-bell', label: 'Live Orders' },
    { key: 'reports', icon: 'fas fa-chart-line', label: 'Reports' },
    // { key: 'marketing', icon: 'fas fa-bullhorn', label: 'Marketing Tools' },
    { key: 'setup', icon: 'fas fa-cog', label: 'Setup' },
    { key: 'support', icon: 'fas fa-life-ring', label: 'Support' },
  ],
  sidebarNavs: {
    liveOrders: [{ label: 'Live Board', route: '/live-orders' }],
    reports: [
      { label: 'Dashboard', route: '/reports/dashboard' },
      { label: 'End of Day', route: '/reports/end-of-day' },
      { label: 'Order List', route: '/reports/orders' },
      // { label: 'Sales Reports', route: '/reports/sales' },
    ],
    // marketing: [
    //   { label: 'Google Business', route: '/marketing/google' },
    //   { label: 'Promotions', route: '/marketing/promotions' },
    //   {
    //     label: 'Flyers & Advertising',
    //     route: '/marketing/advertising',
    //   },
    // ],
    setup: [
      { label: 'Shop Details', route: '/setup/shop-details' },
      { label: 'Opening & Delivery Hours', route: '/setup/services' },
      { label: 'Payments & Fees', route: '/setup/payments' },
      { label: 'Menu Setup', route: '/setup/menu' },
    ],
    support: [
      // { label: 'FAQs', route: '/support/faqs' },
      { label: 'Contact Support', route: '/support/contact' },
    ],
  },
};
